import React, { useState, useEffect, useRef } from "react";
import { Button } from '../../Component/CommonFormEle';
import { GetImageCatogory, CreateImageCatogory, UploadImageDetails, GetCatogoryImage, DeleteCatogoryImage, UpdateImageCatogory } from 'js/Api/index';
import { toast } from "react-hot-toast";
import Loader from '../../../js/Component/Loader'

const ImageManager = () => {

    const [CateogryList, setCateogryList] = useState([]);
    const [ImageList, setImageList] = useState([]);
    const [loading, setloading] = useState(false);
    const [selectedCategory, setselectedCategory] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
    const [previewImage, setPreviewImage] = useState(null);
    const [showUploadPopup, setShowUploadPopup] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [editCategoryItem, seteditCategoryItem] = useState(null);

    const fileInputRef = useRef(null);

    const LoadCategory = async () => {
        const result = await GetImageCatogory();
        if (result.success) {
            setCateogryList(result.data);

            if (result.data.length > 0 && selectedCategory === null) {
                setselectedCategory(result.data[0].id)
                LoadCategoryImages(result.data[0].id)
            }
        }
    }

    const LoadCategoryImages = async (category_id) => {
        const result_images = await GetCatogoryImage(category_id)
        setImageList(result_images.data)
        setSelectedImages([]); // Clear selections on category change
    }

    useEffect(() => {
        LoadCategory();
    }, []);

    const [showCreateCategory, setshowCreateCategory] = useState(false);
    const [newCategoryName, setnewCategoryName] = useState("");

    const CreateNewCategory = async (e) => {
        e.preventDefault();

        if (newCategoryName === "") {
            toast.error("Category Name required");
            return;
        }
        setloading(true)

        if (editCategoryItem != null) {
            const result = await UpdateImageCatogory({ category_name: newCategoryName, category_id: editCategoryItem.id });
            if (result.success) {
                await LoadCategory();
                setnewCategoryName("");
                setshowCreateCategory(false);
            }
            else {
                toast.error("Category already exists.");
            }
        }
        else {
            const result = await CreateImageCatogory({ category_name: newCategoryName });
            if (result.success) {
                await LoadCategory();
                setnewCategoryName("");
                setshowCreateCategory(false);
            }
            else {
                toast.error("Category already exists.");
            }
        }
        setloading(false);
    };

    const EditCategory = async (item) => {
        seteditCategoryItem(item);
        setnewCategoryName(item.categoryName);
        setshowCreateCategory(true);
    }

    const onDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const onDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleFiles = async (files) => {
        if (!selectedCategory) {
            toast.error("Please select a category first.");
            return;
        }

        const validFiles = Array.from(files).filter(file => file.type.startsWith("image/"));
        if (validFiles.length === 0) {
            toast.error("Only image file supported.");
            return;
        }

        setUploadProgress({ current: 1, total: validFiles.length });

        let successCount = 0;
        for (let i = 0; i < validFiles.length; i++) {
            setUploadProgress({ current: i + 1, total: validFiles.length });
            const result = await UploadImageDetails(selectedCategory, validFiles[i]);
            if (result.success) {
                successCount++;
            } else {
                toast.error(`Failed to upload ${validFiles[i].name}`);
            }
        }

        if (successCount > 0) {
            toast.success(`${successCount} of ${validFiles.length} images uploaded successfully.`);
            LoadCategoryImages(selectedCategory);
            setShowUploadPopup(false);
        }
        setUploadProgress({ current: 0, total: 0 });
    };

    const onDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        handleFiles(e.dataTransfer.files);
    };

    const onFileInputChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            handleFiles(e.target.files);
        }
        e.target.value = null; // Reset input so same files can be selected again if needed
    };

    const toggleImageSelection = (imgId) => {
        setSelectedImages(prev =>
            prev.includes(imgId) ? prev.filter(id => id !== imgId) : [...prev, imgId]
        );
    };

    const deleteSelectedImages = async () => {
        if (selectedImages.length === 0) return;

        const confirmDelete = window.confirm(`Are you sure you want to delete ${selectedImages.length} images?`);
        if (!confirmDelete) return;

        setloading(true)
        for (let imgId of selectedImages) {
            await DeleteCatogoryImage(imgId);
        }
        setloading(false)

        LoadCategoryImages(selectedCategory);
        setSelectedImages([]);
    };

    return (
        <div className="midde_cont">
            <div className="container-fluid">
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title">
                            <h2>Day Photos</h2>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div className="col-md-3">
                        <div className="white_shd full">
                            <div className="tabbar padding_infor_info" style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                                <div style={{ minHeight: "72vh", maxHeight: "72vh", overflow: "auto" }}>
                                    <table className="table table-responsive-xl">
                                        <tbody>
                                            {CateogryList !== null && CateogryList.length > 0 &&
                                                <>

                                                    {CateogryList.map((a) => (
                                                        <tr key={a.id}>
                                                            <td onClick={(e) => { e.preventDefault(); LoadCategoryImages(a.id); setselectedCategory(a.id); }}
                                                                style={{
                                                                    border: "0px",
                                                                    backgroundColor: selectedCategory === a.id ? "#C2E7FF" : "#fff", color: "#000", cursor: "pointer", borderRadius: selectedCategory === a.id ? "100px" : "0px"
                                                                }}>
                                                                <div style={{ float: "left" }}>
                                                                    &nbsp;&nbsp;<i class="fa fa-folder"></i>&nbsp;&nbsp;
                                                                    {a.categoryName}
                                                                </div>
                                                                <div style={{ float: "right" }}>
                                                                    <i onClick={(e) => { e.preventDefault(); EditCategory(a); }} class="fa fa-pencil"></i>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            }
                                            <tr>
                                                <td style={{ border: "0px" }}>
                                                    <Button onClick={() => { setshowCreateCategory(true) }} variant="action-popup" style={{ width: "100%", textAlign: "left", border: "0px", paddingLeft: "0px" }}>
                                                        + Create New Category
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="white_shd full">
                            <div className="tabbar padding_infor_info">
                                <div style={{ float: "right" }}>
                                    {selectedImages.length > 0 &&
                                        <>
                                            <i class="fa fa-trash" style={{ fontSize: "1.5rem", marginRight: "10px", border: "1px solid #ccc", padding: "5px 9px 7px 9px" }} onClick={deleteSelectedImages} ></i>
                                            {loading && <Loader />}
                                        </>}
                                    {selectedCategory && (
                                        <Button onClick={() => setShowUploadPopup(true)} variant="blue">
                                            Upload Images
                                        </Button>
                                    )}
                                </div>
                                <div style={{ clear: "both" }}></div>
                                <br />
                                <div style={{ minHeight: "67vh", maxHeight: "67vh", maxWidth: "100%", overflow: "auto" }}>
                                    <div className="row" style={{ width: "100%" }}>
                                        {ImageList && ImageList.length > 0 ? (
                                            ImageList.map((img, index) => (
                                                <div className="col-md-2" key={img.id || index}>
                                                    <div style={{ position: "relative", border: "1px solid #ddd", borderRadius: "8px", overflow: "hidden", maxWidth: "100%" }}>
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "5px",
                                                                right: "5px",
                                                                zIndex: 10,
                                                                padding: "2px"
                                                            }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedImages.includes(img.id)}
                                                                onChange={() => toggleImageSelection(img.id)}
                                                                style={{ cursor: "pointer", width: "16px", height: "16px" }}
                                                            />
                                                        </div>
                                                        <div style={{ cursor: "pointer", height: "150px" }} onClick={() => setPreviewImage(img.imageURL)} >
                                                            <img src={img.imageURL} alt={`Category Image ${index}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="col-md-12">
                                                <p>No images found in this category.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {console.log(editCategoryItem)}
                {showCreateCategory && (
                    <div className="modal">
                        <div className="modal-content" style={{ width: "400px" }}>
                            <div className="modal-header">
                                <h1>{editCategoryItem != null ? "Update" : "New"} Category</h1>
                                <Button onClick={() => { setshowCreateCategory(false); seteditCategoryItem(null); }} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <form className="contact-form">
                                <div className="form-group mt-2">
                                    <label>Category Name</label>
                                    <input className="form-control" type="text" name="categoryName" value={newCategoryName} onChange={(e) => { setnewCategoryName(e.target.value) }} />
                                </div>
                                <div className="modal-footer">
                                    {loading && <Loader />}
                                    <Button onClick={() => { setshowCreateCategory(false); seteditCategoryItem(null); }} variant="cancel">
                                        Cancel
                                    </Button>

                                    <Button onClick={CreateNewCategory} variant="blue" disabled={loading}>
                                        {editCategoryItem != null ? "Update" : "Create"}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {showUploadPopup && (
                    <div className="modal">
                        <div className="modal-content" style={{ width: "800px", maxWidth: "90%" }}>
                            <div className="modal-header">
                                <h1>Upload Images</h1>
                                <Button onClick={() => setShowUploadPopup(false)} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <div className="modal-body">
                                <div
                                    id="drap_drop_container"
                                    onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                    onDragOver={onDragOver}
                                    onDragLeave={onDragLeave}
                                    onDrop={onDrop}
                                    style={{
                                        border: isDragging ? "2px dashed #007bff" : "2px dashed #ccc",
                                        borderRadius: "10px",
                                        padding: "50px",
                                        textAlign: "center",
                                        backgroundColor: isDragging ? "#e9f5ff" : "#f9f9f9",
                                        transition: "all 0.3s ease",
                                        minHeight: "200px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer"
                                    }}
                                >
                                    {uploadProgress.total > 0 ? (
                                        <h4>{uploadProgress.current} of {uploadProgress.total} is uploading...</h4>
                                    ) : (
                                        <h4>Drag & Drop image files here or click to browse</h4>
                                    )}
                                    <input
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        ref={fileInputRef}
                                        onChange={onFileInputChange}
                                        style={{ display: "none" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {previewImage && (
                    <>
                        <div className="modal">
                            <div className="modal-content" style={{ maxWidth: "90%" }}>
                                <div className="modal-header">
                                    <h1>Image Preview</h1>
                                    <Button onClick={() => setPreviewImage(null)} variant="modal-close">
                                        &times;
                                    </Button>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <img src={previewImage} alt="Preview" style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "8px", objectFit: "contain" }} />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div >
    );
}

export default ImageManager;